
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.893 2.852h-8c-.631 0-1.143.511-1.143 1.142V6.28c0 .631.512 1.143 1.143 1.143h8c.631 0 1.143-.512 1.143-1.143V3.994c0-.63-.512-1.142-1.143-1.142z","stroke":"#545C69","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.955 10.28c0-.315.256-.57.572-.57h8c.315 0 .571.255.571.57v2.286a.571.571 0 01-.571.572h-1.631l-1 .602-.323.54h2.954c.947 0 1.714-.767 1.714-1.714v-2.285c0-.947-.767-1.715-1.714-1.715h-8c-.947 0-1.715.768-1.715 1.715v2.285c0 .947.768 1.715 1.715 1.715h2.99l-.38-1.143h-2.61a.571.571 0 01-.572-.572v-2.285z","fill":"#545C69"}}),_c('path',{attrs:{"d":"M9.399 15.13L7.96 10.8l4.312 1.444-1.796 1.082-1.078 1.804z","fill":"#545C69"}})])
          )
        }
      }
    